// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ChangeRequestGroupModalQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ChangeRequestGroupModalQuery = { __typename?: 'Query', changeRequestGroup: { __typename?: 'ChangeRequestGroup', id: string, name: string, salesforceOpportunityLink?: string | null | undefined, underContract?: boolean | null | undefined } };

export type SaveChangeRequestGroupMutationVariables = Types.Exact<{
  input: Types.SaveChangeRequestGroupInput;
}>;


export type SaveChangeRequestGroupMutation = { __typename?: 'Mutation', saveChangeRequestGroup: { __typename?: 'SaveChangeRequestGroupResult', changeRequestGroup: { __typename?: 'ChangeRequestGroup', id: string, name: string, salesforceOpportunityLink?: string | null | undefined, underContract?: boolean | null | undefined } } };

export type DeleteChangeRequestGroupMutationVariables = Types.Exact<{
  input: Types.DeleteEntityInput;
}>;


export type DeleteChangeRequestGroupMutation = { __typename?: 'Mutation', deleteChangeRequestGroup: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };


export const ChangeRequestGroupModalDocument = gql`
    query ChangeRequestGroupModal($id: ID!) {
  changeRequestGroup(id: $id) {
    id
    name
    salesforceOpportunityLink
    underContract
  }
}
    `;

/**
 * __useChangeRequestGroupModalQuery__
 *
 * To run a query within a React component, call `useChangeRequestGroupModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeRequestGroupModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeRequestGroupModalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChangeRequestGroupModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChangeRequestGroupModalQuery, ChangeRequestGroupModalQueryVariables> & ({ variables: ChangeRequestGroupModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChangeRequestGroupModalQuery, ChangeRequestGroupModalQueryVariables>(ChangeRequestGroupModalDocument, options);
      }
export function useChangeRequestGroupModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChangeRequestGroupModalQuery, ChangeRequestGroupModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChangeRequestGroupModalQuery, ChangeRequestGroupModalQueryVariables>(ChangeRequestGroupModalDocument, options);
        }
export function useChangeRequestGroupModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeRequestGroupModalQuery, ChangeRequestGroupModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChangeRequestGroupModalQuery, ChangeRequestGroupModalQueryVariables>(ChangeRequestGroupModalDocument, options);
        }
export type ChangeRequestGroupModalQueryHookResult = ReturnType<typeof useChangeRequestGroupModalQuery>;
export type ChangeRequestGroupModalLazyQueryHookResult = ReturnType<typeof useChangeRequestGroupModalLazyQuery>;
export type ChangeRequestGroupModalSuspenseQueryHookResult = ReturnType<typeof useChangeRequestGroupModalSuspenseQuery>;
export type ChangeRequestGroupModalQueryResult = Apollo.QueryResult<ChangeRequestGroupModalQuery, ChangeRequestGroupModalQueryVariables>;
export const SaveChangeRequestGroupDocument = gql`
    mutation SaveChangeRequestGroup($input: SaveChangeRequestGroupInput!) {
  saveChangeRequestGroup(input: $input) {
    changeRequestGroup {
      id
      name
      salesforceOpportunityLink
      underContract
    }
  }
}
    `;
export type SaveChangeRequestGroupMutationFn = Apollo.MutationFunction<SaveChangeRequestGroupMutation, SaveChangeRequestGroupMutationVariables>;

/**
 * __useSaveChangeRequestGroupMutation__
 *
 * To run a mutation, you first call `useSaveChangeRequestGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveChangeRequestGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveChangeRequestGroupMutation, { data, loading, error }] = useSaveChangeRequestGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveChangeRequestGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveChangeRequestGroupMutation, SaveChangeRequestGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveChangeRequestGroupMutation, SaveChangeRequestGroupMutationVariables>(SaveChangeRequestGroupDocument, options);
      }
export type SaveChangeRequestGroupMutationHookResult = ReturnType<typeof useSaveChangeRequestGroupMutation>;
export type SaveChangeRequestGroupMutationResult = Apollo.MutationResult<SaveChangeRequestGroupMutation>;
export type SaveChangeRequestGroupMutationOptions = Apollo.BaseMutationOptions<SaveChangeRequestGroupMutation, SaveChangeRequestGroupMutationVariables>;
export const DeleteChangeRequestGroupDocument = gql`
    mutation DeleteChangeRequestGroup($input: DeleteEntityInput!) {
  deleteChangeRequestGroup(input: $input) {
    emptyResult
  }
}
    `;
export type DeleteChangeRequestGroupMutationFn = Apollo.MutationFunction<DeleteChangeRequestGroupMutation, DeleteChangeRequestGroupMutationVariables>;

/**
 * __useDeleteChangeRequestGroupMutation__
 *
 * To run a mutation, you first call `useDeleteChangeRequestGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChangeRequestGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChangeRequestGroupMutation, { data, loading, error }] = useDeleteChangeRequestGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteChangeRequestGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteChangeRequestGroupMutation, DeleteChangeRequestGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteChangeRequestGroupMutation, DeleteChangeRequestGroupMutationVariables>(DeleteChangeRequestGroupDocument, options);
      }
export type DeleteChangeRequestGroupMutationHookResult = ReturnType<typeof useDeleteChangeRequestGroupMutation>;
export type DeleteChangeRequestGroupMutationResult = Apollo.MutationResult<DeleteChangeRequestGroupMutation>;
export type DeleteChangeRequestGroupMutationOptions = Apollo.BaseMutationOptions<DeleteChangeRequestGroupMutation, DeleteChangeRequestGroupMutationVariables>;